import { defineMessages, IntlShape } from "react-intl";

enum DeleteReason {
  RUN,
  BIKING,
  WALK,
  PUBLIC_TRANSPORT,
  INACCURATE,
  PASSENGER,
  OTHER,
}

export const allDeleteReasons = [
  DeleteReason.RUN,
  DeleteReason.BIKING,
  DeleteReason.WALK,
  DeleteReason.PUBLIC_TRANSPORT,
  DeleteReason.INACCURATE,
  DeleteReason.PASSENGER,
  DeleteReason.OTHER,
] as const;

const deleteReasonMessages = defineMessages<DeleteReason>({
  [DeleteReason.BIKING]: {
    id: "reports.mileageTracking.deleteReason.biking",
    defaultMessage: "It was biking",
    description: "Biking delete reason for mileage tracking",
  },
  [DeleteReason.INACCURATE]: {
    id: "reports.mileageTracking.deleteReason.inaccurate",
    defaultMessage: "The route was inaccurate",
    description: "Inaccurate delete reason for mileage tracking",
  },
  [DeleteReason.OTHER]: {
    id: "reports.mileageTracking.deleteReason.other",
    defaultMessage: "Other reason",
    description: "Other delete reason for mileage tracking",
  },
  [DeleteReason.PASSENGER]: {
    id: "reports.mileageTracking.deleteReason.passenger",
    defaultMessage: "I was a passenger",
    description: "Passenger delete reason for mileage tracking",
  },
  [DeleteReason.PUBLIC_TRANSPORT]: {
    id: "reports.mileageTracking.deleteReason.publicTransport",
    defaultMessage: "It was public transport",
    description: "Public transport delete reason for mileage tracking",
  },
  [DeleteReason.RUN]: {
    id: "reports.mileageTracking.deleteReason.run",
    defaultMessage: "It was a run",
    description: "Run delete reason for mileage tracking",
  },
  [DeleteReason.WALK]: {
    id: "reports.mileageTracking.deleteReason.walk",
    defaultMessage: "It was a walk",
    description: "Walk delete reason for mileage tracking",
  },
});

const deleteReasonMessagesForManyTrips = defineMessages<DeleteReason>({
  [DeleteReason.BIKING]: {
    id: "reports.mileageTracking.deleteReason.biking.bulk",
    defaultMessage: "They were biking",
    description: "Biking delete reason for bulk-removal in mileage tracking",
  },
  [DeleteReason.INACCURATE]: {
    id: "reports.mileageTracking.deleteReason.inaccurate.bulk",
    defaultMessage: "The routes were inaccurate",
    description: "Inaccurate delete reason for bulk-removal in mileage tracking",
  },
  [DeleteReason.OTHER]: {
    id: "reports.mileageTracking.deleteReason.other.bulk",
    defaultMessage: "Other reason",
    description: "Other delete reason for bulk-removal in mileage tracking",
  },
  [DeleteReason.PASSENGER]: {
    id: "reports.mileageTracking.deleteReason.passenger.bulk",
    defaultMessage: "I was a passenger",
    description: "Passenger delete reason for bulk-removal in mileage tracking",
  },
  [DeleteReason.PUBLIC_TRANSPORT]: {
    id: "reports.mileageTracking.deleteReason.publicTransport.bulk",
    defaultMessage: "They were public transport",
    description: "Public transport delete reason for bulk-removal in mileage tracking",
  },
  [DeleteReason.RUN]: {
    id: "reports.mileageTracking.deleteReason.run.bulk",
    defaultMessage: "They were runs",
    description: "Run delete reason for bulk-removal in mileage tracking",
  },
  [DeleteReason.WALK]: {
    id: "reports.mileageTracking.deleteReason.walk.bulk",
    defaultMessage: "They were walks",
    description: "Walk delete reason for bulk-removal in mileage tracking",
  },
});

export const getDeleteReasonDisplayName = (
  intl: IntlShape,
  deleteReason: DeleteReason,
  bulk?: boolean
) =>
  intl.formatMessage(
    (bulk ? deleteReasonMessagesForManyTrips : deleteReasonMessages)[deleteReason]
  );

export default DeleteReason;
